module.exports = __webpack_public_path__ + "static/media/service-04.c1f4a19d.webm";